
import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { PaginatorModule } from 'primeng/paginator';
import { EventHistory } from 'src/app/core-module/models/Events/event-history';
import { UtilService } from 'src/app/core-module/services/util.service';

@Component({
  selector: 'app-event-history-timeline',
  standalone: true,
  imports: [PaginatorModule],
  templateUrl: './event-history-timeline.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './event-history-timeline.component.scss'
})
export class EventHistoryTimelineComponent implements OnChanges {
  @Input() history: EventHistory[] = [];

  pageSize: number = 5;
  pageIndex: number = 0;

  constructor(public util: UtilService){}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['history']) {
      this.pageIndex = 0;
    }
  }

  get pagedHistory(): EventHistory[] {
    const start = this.pageIndex * this.pageSize;
    return this.history.slice(start, start + this.pageSize);
  }

  totalPages(): number {
    return Math.ceil((this.history?.length || 0) / this.pageSize);
  }

  onPageChange(event: any){
    this.pageIndex = event.page ?? 0;
    this.pageSize = event.rows ?? this.pageSize;
  }
}
